<template>
  <v-card style="height: 100%;" class="ml-2 content-card" elevation="1">
    <v-card-title class="card-title">
      報告預覽區
      <v-spacer></v-spacer>
      <v-btn icon small @click="$emit('refresh')" color="grey">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div class="generated-text-area diff-container">
        <template v-for="(part, index) in diffs">
          <v-tooltip v-if="part.isChanged && part.oldValue" :key="index" top>
            <template v-slot:activator="{ on, attrs }">
              <span class="highlight" v-bind="attrs" v-on="on">{{ part.value }}</span>
            </template>
            <span>{{ part.oldValue }}</span>
          </v-tooltip>
          <span v-else :key="index" :class="{ highlight: part.isChanged }">{{ part.value }}</span>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ReportCard',
  props: {
    diffs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.content-card {
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #eef1f6;
  box-shadow: 0 1px 3px rgba(18, 38, 63, 0.06);
}

.card-title {
  font-size: 1.08rem;
  font-weight: 600;
  color: #2f3542;
  padding: 14px 16px 6px;
}

.v-card__text {
  padding: 8px 16px 16px;
  color: #4a4f57;
  line-height: 1.6;
}

.generated-text-area {
  background-color: #f9fafc;
  border-radius: 10px;
  border: 1px solid #e6e9ef;
  padding: 10px;
  height: 400px; /* Or adjust as needed */
  overflow-y: auto;
  white-space: pre-wrap; /* To respect newlines and spaces */
  line-height: 1.6;
}

.highlight {
  background-color: #fff3cd; /* A pleasant yellow highlight */
  cursor: pointer;
}
</style>
